// src/components/layout/Footer/BreadcrumbNavigation.jsx

'use client'

import Link from 'next/link';
import { Fragment } from 'react';
import { usePathname } from 'next/navigation';
import { splitAndCapitalize } from '@/lib/functions.utils';
// import dynamic from 'next/dynamic';
import { BreadcrumbSchema } from '@/lib/schema';
import styles from './BreadcrumbNavigation.module.scss';

// Dynamically import the BreadcrumbSchema component
// const BreadcrumbSchema = dynamic(() => import('@/lib/schema').then(mod => mod.BreadcrumbSchema), { ssr: true });


export default function BreadcrumbNavigation({lang, homeTxt, ariaTxt}) {

  const pathname = usePathname();  // needs to be use client because of this
  const pathBits = pathname.split('/').filter(Boolean); // Filter out empty path bits

  let accumulatedPath = `/${lang}`;
  
  // Create breadcrumb items for schema
  const breadcrumbItems = pathBits.map((path, idx) => {
    if (idx === 0) {
      return {
        name: homeTxt,
        url: `/${lang}`
      };
    }
    
    accumulatedPath += `/${path}`;
    return {
      name: splitAndCapitalize(path),
      url: accumulatedPath
    };
  });
  
  // Reset accumulated path for UI rendering
  accumulatedPath = `/${lang}`;

  const formatted = pathBits.map((path, idx) => {
    const isLast = idx === pathBits.length - 1;
    if (idx === 0) {
      return (
        <Link key={path} href={`/${lang}`} prefetch={false} aria-current={isLast ? 'page' : undefined}>{homeTxt}</Link>
      );
    }
    accumulatedPath += `/${path}`; // Build up the accumulated path
    return (
      <Fragment key={path}>
        /
        {isLast ? (
          <span aria-current="page">{splitAndCapitalize(path)}</span>
        ) : (
          <Link href={accumulatedPath} prefetch={false}>{splitAndCapitalize(path)}</Link>
        )}
      </Fragment>
    );
  });

  return (
    <>
      {/* Add breadcrumb structured data for SEO */}
      <BreadcrumbSchema items={breadcrumbItems} />

      <nav className={styles.breadcrumb} aria-label={ariaTxt}>{formatted}</nav>
    </>
  );
}
